import { NewVehicle } from './NewVehicle';

export const EmptyVehicle: NewVehicle = {
    vin: '',
    vinValid: false,
    vinOwned: false,
    makeCode: '',
    make: '',
    year: '',
    model: '',
    trim: '',
    color: 'default',
    estMileage: '',
    makeId: '',
    modelId: '',
    option: '',
    optionId: '',
    engine: '',
    engineId: '',
    spgModel: '',
    spgModelId: '',
};
